import packageDetailsContentMap from "@/config/packageDetailsContentMap"

export default {
    packageInfoContent: (state: any) => {
    const {packCode} = state
	if (!packCode)
		throw new Error("packCode is mandatory in getPackageDetailsContent");
	if (!packageDetailsContentMap.has(packCode)) {
		console.error(`no content variables for ${packCode}`);
		return;
	}

	const contentVariabels = packageDetailsContentMap.get(packCode);

	if (!contentVariabels) {
		console.error(`no content variables for ${packCode}`);
		return;
	}

	const values: string[] = [];
	for (const contentVariableName of contentVariabels) {
		values.push(state.content[contentVariableName]);
	}

	return values;
    }
}